import moment from 'moment-timezone';
import getActivityLogs from './api/activityLog/getActivityLogs';
import exportActivityLogCsv from './api/activityLog/exportActivityLogsCsv';

const ACTION_NAME = 'actionLog';

/** Action一覧 */
export const ActionTypes = {
  INIT_SEARCH_DATE: `${ACTION_NAME}/INIT_SEARCH_DATE`,
  SUCCESS_API_GET_ACTION_LOGS: `${ACTION_NAME}/SUCCESS_API_GET_ACTION_LOGS`,
  SUCCESS_API_GET_GROUPS: `${ACTION_NAME}/SUCCESS_API_GET_GROUPS`,
  SUCCESS_API_GET_OPERATORS: `${ACTION_NAME}/SUCCESS_API_GET_OPERATORS`,
  UPDATE_SEARCH_START_DATE: `${ACTION_NAME}/UPDATE_SEARCH_START_DATE`,
  UPDATE_SEARCH_END_DATE: `${ACTION_NAME}/UPDATE_SEARCH_END_DATE`,
  UPDATE_SEARCH_DEVICE_NAME: `${ACTION_NAME}/UPDATE_SEARCH_DEVICE_NAME`,
  UPDATE_SEARCH_ACTION: `${ACTION_NAME}/UPDATE_SEARCH_ACTION`,
  UPDATE_SEARCH_GROUP: `${ACTION_NAME}/UPDATE_SEARCH_GROUP`,
  UPDATE_SEARCH_OPERATOR: `${ACTION_NAME}/UPDATE_SEARCH_OPERATOR`,
  UPDATE_SEARCH_PAGE: `${ACTION_NAME}/UPDATE_SEARCH_PAGE`,
  UPDATE_MEDIA: `${ACTION_NAME}/UPDATE_MEDIA`,
};

/**
 * アクションログの取得
 * @param {*} dispatch dispatch
 * @param {*} apiToken apiToken
 * @param {*} params リクエストパラメータ
 */
export const getActionLogs = (dispatch, apiToken, params) => {
  dispatch(
    getActivityLogs(apiToken, params, ActionTypes.SUCCESS_API_GET_ACTION_LOGS),
  );
};

/**
 * ログCSVのダウンロード
 * @param {*} dispatch dispatch
 * @param {*} apiToken apiToken
 * @param {*} params リクエストパラメータ
 */
export const downloadLogsCsv = (dispatch, apiToken, params) => {
  dispatch(exportActivityLogCsv(apiToken, params));
};

/**
 * 選択済みのアクションリストに変換する
 * @param {*} actions i18nアクション名称リスト
 * @param {*} selecteds 選択されたindexリスト
 */
export const convertSelectedActionList = (actions, selecteds) =>
  selecteds.map(value => Object.keys(actions)[value]);

/**
 * 選択済みのグループリストに変換する
 * @param {*} groups グループ情報一覧
 * @param {*} selecteds 選択されたindexリスト
 */
export const convertSelectedGroupList = (groups, selecteds) =>
  selecteds.map(value => groups[value].id);

/**
 * 選択済みのオペレーターリストに変換する
 * @param {*} operators オペレーター情報一覧
 * @param {*} selecteds 選択されたindexリスト
 */
export const convertSelectedOperatorList = (operators, selecteds) =>
  selecteds.map(value => operators[value].operatorId);

/**
 * ISOFormatの日付をタイムゾー'Asia/Tokyo'にて変換
 * @param {*} date ISOFormatDate
 * @returns YYYY/MM/DD HH:mm（Asia/Tokyo）
 */
export const convertISOFormatToDate = date => {
  const wkDate = moment(date);
  const result =
    (wkDate && wkDate.tz('Asia/Tokyo').format('YYYY/MM/DD HH:mm')) || '';
  return result;
};
